import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {FieldRecordLodgementSuccessModalComponent} from './field-record-lodgement-success-modal.component';

@Injectable({
    providedIn: 'root'
})
export class FieldRecordLodgementSuccessModalService extends ModalService {
    showModal(title: string, message: string) {
        this.createModalComponent(FieldRecordLodgementSuccessModalComponent);
        const fieldRecordLodgementSuccessModalComponent = this.modalComponentRef.instance as FieldRecordLodgementSuccessModalComponent;
        fieldRecordLodgementSuccessModalComponent.title = title;
        fieldRecordLodgementSuccessModalComponent.message = message;
        this.showModalComponent();
        return fieldRecordLodgementSuccessModalComponent.modalClosed;
    }
}
